export const DictionaryPhotoshopWeb = [
    {
        id: 'actionId:10;selectorId:main-menu',
        label: 'Menu : New...',
        placement: 'MenuBar',
        name: 'New...',
    },
    {
        id: 'actionId:20;selectorId:main-menu',
        label: 'Menu : Open...',
        placement: 'MenuBar',
        name: 'Open...',
    },
    {
        id: 'actionId:30;selectorId:main-menu',
        label: 'Menu : Save',
        placement: 'MenuBar',
        name: 'Save',
    },
    {
        id: 'actionId:32;selectorId:main-menu',
        label: 'Menu : Save as...',
        placement: 'MenuBar',
        name: 'Save as...',
    },
    {
        id: 'actionId:101;selectorId:main-menu',
        label: 'Menu : Edit > Undo',
        placement: 'MenuBar',
        name: 'Undo',
    },
    {
        id: 'actionId:103;selectorId:main-menu',
        label: 'Menu : Edit > Cut',
        placement: 'MenuBar',
        name: 'Cut',
    },
    {
        id: 'actionId:104;selectorId:main-menu',
        label: 'Menu : Edit > Copy',
        placement: 'MenuBar',
        name: 'Copy',
    },
    {
        id: 'actionId:105;selectorId:main-menu',
        label: 'Menu : Edit > Paste',
        placement: 'MenuBar',
        name: 'Paste',
    },
    {
        id: 'actionId:132;selectorId:main-menu',
        label: 'Menu : Edit > Redo',
        placement: 'MenuBar',
        name: 'Redo',
    },
    {
        id: 'actionId:1002;selectorId:main-menu',
        label: 'Menu : View > Rulers',
        placement: 'MenuBar',
        name: 'Rulers',
    },
    {
        id: 'actionId:1004;selectorId:zoom-menu',
        label: 'Menu : Zoom in',
        placement: 'MenuBar',
        name: 'Zoom in',
    },
    {
        id: 'actionId:1005;selectorId:zoom-menu',
        label: 'Menu : Zoom out',
        placement: 'MenuBar',
        name: 'Zoom out',
    },
    {
        id: 'actionId:1016;selectorId:main-menu',
        label: 'Menu : Select > Deselect',
        placement: 'MenuBar',
        name: 'Deselect',
    },
    {
        id: 'actionId:1017;selectorId:main-menu',
        label: 'Menu : Select > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 'actionId:1018;selectorId:main-menu',
        label: 'Menu : Select > Inverse',
        placement: 'MenuBar',
        name: 'Inverse',
    },
    {
        id: 'actionId:1032;selectorId:main-menu',
        label: 'Menu : Import...',
        placement: 'MenuBar',
        name: 'Import...',
    },
    {
        id: 'actionId:1033;selectorId:main-menu',
        label: 'Menu : Select > Grow',
        placement: 'MenuBar',
        name: 'Grow',
    },
    {
        id: 'actionId:1034;selectorId:main-menu',
        label: 'Menu : Select > Similar',
        placement: 'MenuBar',
        name: 'Similar',
    },
    {
        id: 'actionId:1044;selectorId:main-menu',
        label: 'Menu : Edit > Crop',
        placement: 'MenuBar',
        name: 'Crop',
    },
    {
        id: 'actionId:1099;selectorId:main-menu',
        label: 'Menu : Layer > New > Layer',
        placement: 'MenuBar',
        name: 'Layer',
    },
    {
        id: 'actionId:1100;selectorId:main-menu',
        label: 'Menu : Layer > Delete > Layer',
        placement: 'MenuBar',
        name: 'Layer',
    },
    {
        id: 'actionId:1107;selectorId:main-menu',
        label: 'Menu : Edit > Copy merged',
        placement: 'MenuBar',
        name: 'Copy merged',
    },
    {
        id: 'actionId:1115;selectorId:main-menu',
        label: 'Menu : Select > Refine edge',
        placement: 'MenuBar',
        name: 'Refine edge',
    },
    {
        id: 'actionId:1135;selectorId:main-menu',
        label: 'Menu : Layer > Duplicate layer',
        placement: 'MenuBar',
        name: 'Duplicate layer',
    },
    {
        id: 'actionId:1190;selectorId:zoom-menu',
        label: 'Menu : 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 'actionId:1192;selectorId:zoom-menu',
        label: 'Menu : Fit to screen',
        placement: 'MenuBar',
        name: 'Fit to screen',
    },
    {
        id: 'actionId:1299;selectorId:zoom-menu',
        label: 'Menu : 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 'actionId:1301;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Drop shadow',
        placement: 'MenuBar',
        name: 'Drop shadow',
    },
    {
        id: 'actionId:1303;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Outer glow',
        placement: 'MenuBar',
        name: 'Outer glow',
    },
    {
        id: 'actionId:1305;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Bevel & emboss',
        placement: 'MenuBar',
        name: 'Bevel & emboss',
    },
    {
        id: 'actionId:1312;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Satin',
        placement: 'MenuBar',
        name: 'Satin',
    },
    {
        id: 'actionId:1313;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Stroke',
        placement: 'MenuBar',
        name: 'Stroke',
    },
    {
        id: 'actionId:1318;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Inner shadow',
        placement: 'MenuBar',
        name: 'Inner shadow',
    },
    {
        id: 'actionId:1320;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Inner glow',
        placement: 'MenuBar',
        name: 'Inner glow',
    },
    {
        id: 'actionId:1335;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Color overlay',
        placement: 'MenuBar',
        name: 'Color overlay',
    },
    {
        id: 'actionId:1336;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Gradient overlay',
        placement: 'MenuBar',
        name: 'Gradient overlay',
    },
    {
        id: 'actionId:1337;selectorId:main-menu',
        label: 'Menu : Layer > New layer effect > Pattern overlay',
        placement: 'MenuBar',
        name: 'Pattern overlay',
    },
    {
        id: 'actionId:1461;selectorId:main-menu',
        label: 'Menu : Select > Subject',
        placement: 'MenuBar',
        name: 'Subject',
    },
    {
        id: 'actionId:1470;selectorId:adjustSectionTool',
        label: 'Tool : Select > Select subject',
        placement: 'Tool',
    },
    {
        id: 'actionId:1510;selectorId:main-menu',
        label: 'Menu : Edit > Fill > Content-aware fill',
        placement: 'MenuBar',
        name: 'Content-aware fill',
    },
    {
        id: 'actionId:1808;selectorId:main-menu',
        label: 'Menu : Image > Auto tone',
        placement: 'MenuBar',
        name: 'Auto tone',
    },
    {
        id: 'actionId:1810;selectorId:main-menu',
        label: 'Menu : Image > Auto contrast',
        placement: 'MenuBar',
        name: 'Auto contrast',
    },
    {
        id: 'actionId:1817;selectorId:main-menu',
        label: 'Menu : Image > Auto color',
        placement: 'MenuBar',
        name: 'Auto color',
    },
    {
        id: 'actionId:1943;selectorId:main-menu',
        label: 'Menu : Select > Reselect',
        placement: 'MenuBar',
        name: 'Reselect',
    },
    {
        id: 'actionId:1971;selectorId:main-menu',
        label: 'Menu : Select > Transform selection',
        placement: 'MenuBar',
        name: 'Transform selection',
    },
    {
        id: 'actionId:2207;selectorId:main-menu',
        label: 'Menu : Edit > Free transform',
        placement: 'MenuBar',
        name: 'Free transform',
    },
    {
        id: 'actionId:2208;selectorId:main-menu',
        label: 'Menu : Edit > Transform > Rotate 180°',
        placement: 'MenuBar',
        name: 'Rotate 180°',
    },
    {
        id: 'actionId:2209;selectorId:main-menu',
        label: 'Menu : Edit > Transform > Rotate 90° clockwise',
        placement: 'MenuBar',
        name: 'Rotate 90° clockwise',
    },
    {
        id: 'actionId:2210;selectorId:main-menu',
        label: 'Menu : Edit > Transform > Rotate 90° counter clockwise',
        placement: 'MenuBar',
        name: 'Rotate 90° counter clockwise',
    },
    {
        id: 'actionId:2211;selectorId:main-menu',
        label: 'Menu : Edit > Transform > Flip horizontal',
        placement: 'MenuBar',
        name: 'Flip horizontal',
    },
    {
        id: 'actionId:2212;selectorId:main-menu',
        label: 'Menu : Edit > Transform > Flip vertical',
        placement: 'MenuBar',
        name: 'Flip vertical',
    },
    {
        id: 'actionId:2311;selectorId:main-menu',
        label: 'Menu : Settings...',
        placement: 'MenuBar',
        name: 'Settings...',
    },
    {
        id: 'actionId:2951;selectorId:main-menu',
        label: 'Menu : Layer > Delete > Hidden layers',
        placement: 'MenuBar',
        name: 'Hidden layers',
    },
    {
        id: 'actionId:2958;selectorId:main-menu',
        label: 'Menu : Layer > Group layers',
        placement: 'MenuBar',
        name: 'Group layers',
    },
    {
        id: 'actionId:2959;selectorId:main-menu',
        label: 'Menu : Layer > Ungroup layers',
        placement: 'MenuBar',
        name: 'Ungroup layers',
    },
    {
        id: 'actionId:2970;selectorId:main-menu',
        label: 'Menu : Layer > New > Layer via copy',
        placement: 'MenuBar',
        name: 'Layer via copy',
    },
    {
        id: 'actionId:2971;selectorId:main-menu',
        label: 'Menu : Layer > New > Layer via cut',
        placement: 'MenuBar',
        name: 'Layer via cut',
    },
    {
        id: 'actionId:2976;selectorId:main-menu',
        label: 'Menu : Layer > New > Group',
        placement: 'MenuBar',
        name: 'Group',
    },
    {
        id: 'actionId:2991;selectorId:main-menu',
        label: 'Menu : Image > Image rotation > Rotate 90° clockwise',
        placement: 'MenuBar',
        name: 'Rotate 90° clockwise',
    },
    {
        id: 'actionId:2992;selectorId:main-menu',
        label: 'Menu : Image > Image rotation > Rotate 90° counter clockwise',
        placement: 'MenuBar',
        name: 'Rotate 90° counter clockwise',
    },
    {
        id: 'actionId:2993;selectorId:main-menu',
        label: 'Menu : Image > Image rotation > Rotate 180°',
        placement: 'MenuBar',
        name: 'Rotate 180°',
    },
    {
        id: 'actionId:2996;selectorId:main-menu',
        label: 'Menu : Image > Image rotation > Flip horizontal',
        placement: 'MenuBar',
        name: 'Flip horizontal',
    },
    {
        id: 'actionId:2997;selectorId:main-menu',
        label: 'Menu : Image > Image rotation > Flip vertical',
        placement: 'MenuBar',
        name: 'Flip vertical',
    },
    {
        id: 'actionId:3083;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Exposure',
        placement: 'MenuBar',
        name: 'Exposure',
    },
    {
        id: 'actionId:3083;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Exposure',
        placement: 'Tool',
    },
    {
        id: 'actionId:3083;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Exposure',
        placement: 'Panel',
    },
    {
        id: 'actionId:3085;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Vibrance',
        placement: 'MenuBar',
        name: 'Vibrance',
    },
    {
        id: 'actionId:3085;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Vibrance',
        placement: 'Tool',
    },
    {
        id: 'actionId:3085;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Vibrance',
        placement: 'Panel',
    },
    {
        id: 'actionId:3443;selectorId:main-menu',
        label: 'Menu : Export as',
        placement: 'MenuBar',
        name: 'Export as',
    },
    {
        id: 'actionId:3503;selectorId:main-menu',
        label: 'Menu : View > Guides',
        placement: 'MenuBar',
        name: 'Guides',
    },
    {
        id: 'actionId:3504;selectorId:main-menu',
        label: 'Menu : View > Grid',
        placement: 'MenuBar',
        name: 'Grid',
    },
    {
        id: 'actionId:3520;selectorId:main-menu',
        label: 'Menu : View > Snap',
        placement: 'MenuBar',
        name: 'Snap',
    },
    {
        id: 'actionId:3521;selectorId:main-menu',
        label: 'Menu : View > Snap to > Guides',
        placement: 'MenuBar',
        name: 'Guides',
    },
    {
        id: 'actionId:3522;selectorId:main-menu',
        label: 'Menu : View > Snap to > Grid',
        placement: 'MenuBar',
        name: 'Grid',
    },
    {
        id: 'actionId:3524;selectorId:main-menu',
        label: 'Menu : View > Snap to > Document bounds',
        placement: 'MenuBar',
        name: 'Document bounds',
    },
    {
        id: 'actionId:3527;selectorId:main-menu',
        label: 'Menu : View > Snap to > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 'actionId:3528;selectorId:main-menu',
        label: 'Menu : View > Snap to > None',
        placement: 'MenuBar',
        name: 'None',
    },
    {
        id: 'actionId:3530;selectorId:main-menu',
        label: 'Menu : View > Snap to > Layers',
        placement: 'MenuBar',
        name: 'Layers',
    },
    {
        id: 'actionId:5959;selectorId:share-menu',
        label: 'Menu : Invite people',
        placement: 'MenuBar',
        name: 'Invite people',
    },
    {
        id: 'actionId:6303;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Levels',
        placement: 'MenuBar',
        name: 'Levels',
    },
    {
        id: 'actionId:6303;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Levels',
        placement: 'Tool',
    },
    {
        id: 'actionId:6303;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Levels',
        placement: 'Panel',
    },
    {
        id: 'actionId:6304;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Curves',
        placement: 'MenuBar',
        name: 'Curves',
    },
    {
        id: 'actionId:6304;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Curves',
        placement: 'Tool',
    },
    {
        id: 'actionId:6304;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Curves',
        placement: 'Panel',
    },
    {
        id: 'actionId:6305;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Color balance',
        placement: 'MenuBar',
        name: 'Color balance',
    },
    {
        id: 'actionId:6305;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Color balance',
        placement: 'Tool',
    },
    {
        id: 'actionId:6305;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Color balance',
        placement: 'Panel',
    },
    {
        id: 'actionId:6306;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Brightness/contrast',
        placement: 'MenuBar',
        name: 'Brightness/contrast',
    },
    {
        id: 'actionId:6306;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Brightness/contrast',
        placement: 'Tool',
    },
    {
        id: 'actionId:6306;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Brightness/contrast',
        placement: 'Panel',
    },
    {
        id: 'actionId:6308;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Hue/saturation',
        placement: 'MenuBar',
        name: 'Hue/saturation',
    },
    {
        id: 'actionId:6308;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Hue/saturation',
        placement: 'Tool',
    },
    {
        id: 'actionId:6308;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Hue/saturation',
        placement: 'Panel',
    },
    {
        id: 'actionId:6313;selectorId:main-menu',
        label: 'Menu : Filter > Invert',
        placement: 'MenuBar',
        name: 'Invert',
    },
    {
        id: 'actionId:6348;selectorId:main-menu',
        label: 'Menu : Layer > New adjustment layer > Black & white',
        placement: 'MenuBar',
        name: 'Black & white',
    },
    {
        id: 'actionId:6348;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Black & white',
        placement: 'Tool',
    },
    {
        id: 'actionId:6348;selectorId:layeractions-adjustment-layers',
        label: 'Panel : Black & white',
        placement: 'Panel',
    },
    {
        id: 'actionId:9643;selectorId:main-menu',
        label: 'Menu : Edit > Fill > Foreground color',
        placement: 'MenuBar',
        name: 'Foreground color',
    },
    {
        id: 'actionId:9644;selectorId:main-menu',
        label: 'Menu : Edit > Fill > Background color',
        placement: 'MenuBar',
        name: 'Background color',
    },
    {
        id: 'actionId:9645;selectorId:main-menu',
        label: 'Menu : Edit > Fill > Black',
        placement: 'MenuBar',
        name: 'Black',
    },
    {
        id: 'actionId:9646;selectorId:main-menu',
        label: 'Menu : Edit > Fill > White',
        placement: 'MenuBar',
        name: 'White',
    },
    {
        id: 'actionId:9647;selectorId:main-menu',
        label: 'Menu : Edit > Fill > 50% gray',
        placement: 'MenuBar',
        name: '50% gray',
    },
    {
        id: 'actionId:100000;selectorId:main-menu',
        label: 'Menu : Back to home',
        placement: 'MenuBar',
        name: 'Back to home',
    },
    {
        id: 'actionId:100001;selectorId:main-menu',
        label: 'Menu : Filter > Gaussian blur',
        placement: 'MenuBar',
        name: 'Gaussian blur',
    },
    {
        id: 'actionId:100001;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Gaussian blur',
        placement: 'Tool',
    },
    {
        id: 'actionId:100002;selectorId:main-menu',
        label: 'Menu : Filter > Camera Raw filter',
        placement: 'MenuBar',
        name: 'Camera Raw filter',
    },
    {
        id: 'actionId:100002;selectorId:adjustSectionTool',
        label: 'Tool : Adjust > Camera Raw filter',
        placement: 'Tool',
    },
    {
        id: 'actionId:100101;selectorId:share-menu',
        label: 'Menu : Open in desktop app',
        placement: 'MenuBar',
        name: 'Open in desktop app',
    },
    {
        id: 'actionId:100201;selectorId:zoom-menu',
        label: 'Menu : Fill screen',
        placement: 'MenuBar',
        name: 'Fill screen',
    },
    {
        id: 'actionId:100202;selectorId:zoom-menu',
        label: 'Menu : Full screen mode',
        placement: 'MenuBar',
        name: 'Full screen mode',
    },
    {
        id: 'actionId:100301;selectorId:main-menu',
        label: 'Menu : View > Context bar',
        placement: 'MenuBar',
        name: 'Context bar',
    },
    {
        id: 'actionId:100302;selectorId:main-menu',
        label: 'Menu : View > Selection bar',
        placement: 'MenuBar',
        name: 'Selection bar',
    },
    {
        id: 'actionId:103201;selectorId:doc-menu',
        label: 'Menu : Rename...',
        placement: 'MenuBar',
        name: 'Rename...',
    },
    {
        id: 'actionId:103202;selectorId:doc-menu',
        label: 'Menu : Document info...',
        placement: 'MenuBar',
        name: 'Document info...',
    },
    {
        id: 'actionId:103203;selectorId:doc-menu',
        label: 'Menu : Image size...',
        placement: 'MenuBar',
        name: 'Image size...',
    },
    {
        id: 'actionId:moveTool;selectorId:section-toolbar-size-position',
        label: 'Tool : Move tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:transformTool;selectorId:section-toolbar-size-position',
        label: 'Tool : Transform tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:lassoTool;selectorId:section-toolbar-select',
        label: 'Tool : Lasso tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:quickSelectTool;selectorId:section-toolbar-select',
        label: 'Tool : Quick selection tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:magicLassoTool;selectorId:section-toolbar-select',
        label: 'Tool : Object selection tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:magicWandTool;selectorId:section-toolbar-select',
        label: 'Tool : Magic wand tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:marqueeRectTool;selectorId:section-toolbar-select',
        label: 'Tool : Rectangular marquee tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:marqueeEllipTool;selectorId:section-toolbar-select',
        label: 'Tool : Elliptical marquee tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:paintbrushTool;selectorId:section-toolbar-paint',
        label: 'Tool : Brush tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:eraserTool;selectorId:section-toolbar-paint',
        label: 'Tool : Eraser tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:bucketTool;selectorId:section-toolbar-paint',
        label: 'Tool : Paint bucket tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:gradientTool;selectorId:section-toolbar-paint',
        label: 'Tool : Gradient tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:dodgeTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Lighten',
        placement: 'Tool',
    },
    {
        id: 'actionId:burnInTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Darken',
        placement: 'Tool',
    },
    {
        id: 'actionId:saturationTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Saturation',
        placement: 'Tool',
    },
    {
        id: 'actionId:smudgeTool;selectorId:section-toolbar-paint',
        label: 'Tool : Smudge tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:spotHealingBrushTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Spot healing brush tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:magicStampTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Healing brush tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:cloneStampTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Clone stamp tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:cropTool;selectorId:section-toolbar-size-position',
        label: 'Tool : Crop tool',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: 'Type tool',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'Eyedropper tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:removeTool;selectorId:section-toolbar-retouch',
        label: 'Tool : Remove tool',
        placement: 'Tool',
    },
    {
        id: 'adjustSectionTool',
        label: 'Adjust',
        placement: 'Tool',
    },
    {
        id: 'adjustSectionTool',
        label: 'Adjust',
        placement: 'Tool',
    },
    {
        id: 'quickActionsTool',
        label: 'Quick actions',
        placement: 'Tool',
    },
    {
        id: 'editBackgroundTool',
        label: 'Edit background',
        placement: 'Tool',
    },
    {
        id: 'placeTool',
        label: 'Import tool',
        placement: 'Tool',
    },
    {
        id: 'actionId:-103300;selectorId:doc-menu',
        label: 'Menu : Version history',
        placement: 'MenuBar',
        name: 'Version history',
    },
    {
        id: 'panelid.static.toolbar',
        label: 'Tool panel',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.options',
        label: 'Tool settings',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.contextbar',
        label: 'Contextual task bar',
        placement: 'Panel',
    },
    {
        id: 'actionId:panelid.static.layers;selectorId:taskbar-toggle-layers',
        label: 'Panel : Layers panel',
        placement: 'Panel',
    },
    {
        id: 'actionId:panelid.static.properties;selectorId:taskbar-toggle-layer-properties',
        label: 'Panel : Properties panel',
        placement: 'Panel',
    },
    {
        id: 'actionId:panelid.static.comments;selectorId:taskbar-toggle-comments',
        label: 'Panel : Comments panel',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.taskbar',
        label: 'Task bar',
        placement: 'Panel',
    },
    {
        id: 'actionId:panelid.static.dp_drawer;selectorId:help-button',
        label: 'Panel : Help',
        placement: 'Panel',
    },
    {
        id: 'main-menu',
        label: 'Main menu',
        placement: 'MenuBar',
    },
    {
        id: 'doc-menu',
        label: 'Document menu',
        placement: 'MenuBar',
    },
    {
        id: 'zoom-menu',
        label: 'Zoom menu',
        placement: 'MenuBar',
    },
    {
        id: 'free-trial-button',
        label: 'Free trial',
        placement: 'MenuBar',
    },
    {
        id: 'upgrade-button',
        label: 'Upgrade',
        placement: 'MenuBar',
    },
    {
        id: 'get-desktop-button',
        label: 'Get desktop',
        placement: 'MenuBar',
    },
    {
        id: 'request-access-button',
        label: 'Request access',
        placement: 'MenuBar',
    },
    {
        id: 'open-in-menu',
        label: 'Open in',
        placement: 'MenuBar',
    },
    {
        id: 'open-in-desktop-button',
        label: 'Open in desktop',
        placement: 'MenuBar',
    },
    {
        id: 'undo-button',
        label: 'Undo',
        placement: 'MenuBar',
    },
    {
        id: 'redo-button',
        label: 'Redo',
        placement: 'MenuBar',
    },
    {
        id: 'download-button',
        label: 'Download',
        placement: 'MenuBar',
    },
    {
        id: 'share-menu',
        label: 'Share menu',
        placement: 'MenuBar',
    },
    {
        id: 'feedback-menu',
        label: 'Feedback menu',
        placement: 'MenuBar',
    },
    {
        id: 'help-button',
        label: 'Help',
        placement: 'MenuBar',
    },
    {
        id: 'account-menu',
        label: 'Account menu',
        placement: 'MenuBar',
    },
    {
        id: 'sign-in-button',
        label: 'Sign in',
        placement: 'MenuBar',
    },
    {
        id: 'section-toolbar-size-position',
        label: 'Size & position',
        placement: 'Tool',
    },
    {
        id: 'section-toolbar-adjust',
        label: 'Adjust',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-brightness-contrast',
        label: 'Brightness contrast',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-hue-saturation',
        label: 'Hue saturation',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-exposure',
        label: 'Exposure',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-vibrance',
        label: 'Vibrance',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-color-balance',
        label: 'Color balance',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-black-white',
        label: 'Black white',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-gaussian-blur',
        label: 'Gaussian blur',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-levels',
        label: 'Levels',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-curves',
        label: 'Curves',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-camera-raw-filter',
        label: 'Camera RAW filter',
        placement: 'Tool',
    },
    {
        id: 'section-toolbar-select',
        label: 'Select',
        placement: 'Tool',
    },
    {
        id: 'toolbar-action-select-subject',
        label: 'Select subject',
        placement: 'Tool',
    },
    {
        id: 'section-toolbar-retouch',
        label: 'Retouch',
        placement: 'Tool',
    },
    {
        id: 'section-toolbar-paint',
        label: 'Paint',
        placement: 'Tool',
    },
    {
        id: 'text-quickactions-styles',
        label: 'Styles',
        placement: 'Tool',
    },
    {
        id: 'text-quickactions-presets',
        label: 'Presets',
        placement: 'Tool',
    },
    {
        id: 'edit-background-colors',
        label: 'Colors',
        placement: 'Tool',
    },
    {
        id: 'edit-background-custom-color',
        label: 'Custom color',
        placement: 'Tool',
    },
    {
        id: 'edit-background-image',
        label: 'Image',
        placement: 'Tool',
    },
    {
        id: 'toolbar-color-picker',
        label: 'Color picker',
        placement: 'Tool',
    },
    {
        id: 'toolbar-color-picker-foreground',
        label: 'Foreground color picker',
        placement: 'Tool',
    },
    {
        id: 'toolbar-color-switch',
        label: 'Color switch',
        placement: 'Tool',
    },
    {
        id: 'toolbar-color-picker-background',
        label: 'Background color picker',
        placement: 'Tool',
    },
    {
        id: 'taskbar-toggle-layers',
        label: 'Layers',
        placement: 'taskbar',
    },
    {
        id: 'taskbar-toggle-layer-properties',
        label: 'Layer properties',
        placement: 'taskbar',
    },
    {
        id: 'taskbar-toggle-comments',
        label: 'Comments',
        placement: 'taskbar',
    },
    {
        id: 'layeractions-new-layer',
        label: 'Add new layer',
        placement: 'Panel',
    },
    {
        id: 'layeractions-adjustment-layers',
        label: 'Adjustment layers',
        placement: 'Panel',
    },
    {
        id: 'layeractions-layer-effects',
        label: 'Layer effects',
        placement: 'Panel',
    },
    {
        id: 'layeractions-add-layer-mask',
        label: 'Add layer mask',
        placement: 'Panel',
    },
    {
        id: 'layeractions-enable-layer-mask',
        label: 'Enable layer mask',
        placement: 'Panel',
    },
    {
        id: 'layeractions-disable-layer-mask',
        label: 'Disable layer mask',
        placement: 'Panel',
    },
    {
        id: 'layeractions-create-clipping-mask',
        label: 'Create clipping mask',
        placement: 'Panel',
    },
    {
        id: 'layeractions-release-clipping-mask',
        label: 'Release clipping mask',
        placement: 'Panel',
    },
    {
        id: 'layeractions-arrange-layers',
        label: 'Arrange layers',
        placement: 'Panel',
    },
    {
        id: 'layeractions-delete',
        label: 'Delete',
        placement: 'Panel',
    },
    {
        id: 'layeractions-blending-opacity-handle',
        label: 'Blend mode opacity',
        placement: 'Panel',
    },
    {
        id: 'toggle-layer-visibility',
        label: 'Layer visibility',
        placement: 'Panel',
    },
    {
        id: 'properties-font-picker',
        label: 'Font picker',
        placement: 'Panel',
    },
    {
        id: 'properties-font-size',
        label: 'Font size',
        placement: 'Panel',
    },
    {
        id: 'properties-font-fill-color',
        label: 'Font fill color',
        placement: 'Panel',
    },
    {
        id: 'properties-hue-sat-slider-hue',
        label: 'Hue slider',
        placement: 'Panel',
    },
    {
        id: 'properties-hue-sat-slider-saturation',
        label: 'Saturation slider',
        placement: 'Panel',
    },
    {
        id: 'properties-hue-sat-reset',
        label: 'Reset button',
        placement: 'Panel',
    },
    {
        id: 'toolsettings-brush-size-hardness',
        label: 'Brush size and hardness settings',
        placement: 'Tool',
    },
    {
        id: 'toolsettings-brush-size-slider',
        label: 'Brush size settings',
        placement: 'Tool',
    },
    {
        id: 'toolsettings-brush-hardness-slider',
        label: 'Brush hardness settings',
        placement: 'Tool',
    },
    {
        id: 'toolactions-select-more',
        label: 'Select more',
        placement: 'Tool',
    },
    {
        id: 'toolactions-select-less',
        label: 'Select less',
        placement: 'Tool',
    },
    {
        id: 'toolactions-create-mask',
        label: 'Create mask from selection',
        placement: 'Tool',
    },
    {
        id: 'toolactions-invert-selection',
        label: 'Invert selection',
        placement: 'Tool',
    },
    {
        id: 'toolactions-deselect',
        label: 'Deselect',
        placement: 'Tool',
    },
    {
        id: 'toolactions-caf',
        label: 'Content-aware fill',
        placement: 'Tool',
    },
];
